module.exports = __webpack_public_path__ + "static/image/history/pc/201012.jpg?d304d5ff";